import { parsePhoneNumber } from "../../utils/parsePhoneNumber";

export const formatPhoneNumber = (phoneNumber: string, _lng?: string) =>
  parsePhoneNumber(phoneNumber)?.formatNational() || phoneNumber;
